module.exports = __webpack_public_path__ + "img/eyebrow_female_straight_average.c88a8821.png";